import { render } from "./PrintEditFoodOrderStep-3.vue?vue&type=template&id=3e8f2bd8"
import script from "./PrintEditFoodOrderStep-3.vue?vue&type=script&lang=js"
export * from "./PrintEditFoodOrderStep-3.vue?vue&type=script&lang=js"

import "./PrintEditFoodOrderStep-3.vue?vue&type=style&index=0&id=3e8f2bd8&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__